import React from 'react';
import { withRouter } from 'react-router-dom';
import Content from './Content/Content';
import SideMenu from './SideMenu/SideMenu';
import './Okupace.css';

const Okupace = props => {
  const { location } = props;

  return (
    <div id="okupace">
      <Content />
      {location.pathname !== '/' && <SideMenu />}
    </div>
  );
};

export default withRouter(Okupace);



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Okupace.js